/** `documents` namespace — Swedish (source of truth). */
const documents = {
  list: {
    searchPlaceholder: 'Sök efter filer…',
    noSearchResults: 'Inga filer matchade sökningen',
    columns: {
      name: 'Namn',
      date: 'Datum',
      size: 'Storlek',
      owner: 'Ägare',
    },
    selectAll: 'Markera alla',
    rowMenu: 'Fler åtgärder',
    selectedCount_one: '{{count}} vald',
    selectedCount_other: '{{count}} valda',
    addToTag: 'Lägg till i tagg',
    deleteSelected: 'Ta bort',
    clearSelection: 'Avmarkera',
    dropOverlay: 'Släpp filerna här för att ladda upp',
    bulkDeleteDialog: {
      title: 'Ta bort filer',
      description_one:
        'Är du säker på att du vill ta bort {{count}} fil? Detta går inte att ångra.',
      description_other:
        'Är du säker på att du vill ta bort {{count}} filer? Detta går inte att ångra.',
    },
    sortLabel: 'Sortera:',
    sortUpdated: 'Senast uppdaterad',
    sortName: 'Namn',
    listView: 'Listvy',
    gridView: 'Rutnätsvy',
    reindex: 'Reindexera',
    regenerateMarkdown: 'Regenerera markdown',
    upload: 'Ladda upp',
    newDocument: 'Nytt dokument',
    showTags: 'Visa taggar',
    hideTags: 'Dölj taggar',
    loading: 'Laddar...',
    empty: 'Inga dokument',
    uploadFiles: 'Ladda upp filer',
    createDocument: 'Skapa dokument',
    updated: 'Uppdaterad {{date}}',
    delete: 'Ta bort',
    manageTags: 'Hantera taggar',
    noTagsYet: 'Inga taggar skapade ännu',
    maxTags: 'Max {{count}} taggar',
    documentCount_one: '{{count}} dokument',
    documentCount_other: '{{count}} dokument',
    conversion: {
      converting: 'Konverterar...',
      completed: 'Klar',
      failed: 'Misslyckades',
    },
    deleteDialog: {
      title: 'Ta bort dokument',
      description: 'Är du säker på att du vill ta bort "{{title}}"? Detta går inte att ångra.',
      cancel: 'Avbryt',
      confirm: 'Ta bort',
      deleting: 'Tar bort...',
    },
  },
  meetingNotes: {
    writing: 'HUB skriver mötesanteckningarna…',
    failed: 'HUB kunde inte skriva mötesanteckningarna. Be en administratör köra om dem.',
    fromRecording: 'Anteckningarna uppdaterades från inspelningen',
  },
  editor: {
    loadError: 'Kunde inte ladda dokumentet',
    loadingPdf: 'Laddar PDF...',
    loadingEditor: 'Laddar editor...',
    converting: 'Konverterar dokument...',
    loadingSpreadsheet: 'Laddar kalkylblad...',
    loadingImage: 'Laddar bild...',
  },
  spreadsheet: {
    loadError: 'Kunde inte ladda kalkylbladet',
    empty: 'Kalkylbladet är tomt',
    rows_one: '{{count}} rad',
    rows_other: '{{count}} rader',
    showingFirst: 'Visar de första {{count}} raderna',
    search: 'Sök i tabellen...',
    noMatches: 'Inga rader matchar',
    download: 'Ladda ner originalfil',
  },
  tags: {
    all: 'Alla',
    untagged: 'Otaggade',
    rename: 'Byt namn',
    recolor: 'Byt färg',
    delete: 'Ta bort',
    new: 'Ny tagg',
    namePlaceholder: 'Taggnamn...',
    cancel: 'Avbryt',
    create: 'Skapa',
    save: 'Spara',
    colors: {
      gray: 'Grå',
      red: 'Röd',
      orange: 'Orange',
      yellow: 'Gul',
      green: 'Grön',
      teal: 'Teal',
      blue: 'Blå',
      indigo: 'Indigo',
      purple: 'Lila',
      pink: 'Rosa',
    },
    renameDialog: {
      title: 'Byt namn på tagg',
    },
    recolorDialog: {
      title: 'Byt färg på tagg',
      description: 'Välj en ny färg för <strong>{{name}}</strong>',
    },
    deleteDialog: {
      title: 'Ta bort tagg',
      description:
        'Taggen <strong>{{name}}</strong> tas bort. Dokument som har taggen påverkas inte.',
    },
  },
  upload: {
    uploading: 'Laddar upp…',
    uploadDone: 'Uppladdning klar',
    dismiss: 'Stäng',
    dropHere: 'Dra filer hit eller <pick>klicka för att välja</pick>',
    hint: 'PDF, Word, Excel, PowerPoint, CSV, TXT, bilder (max 50 MB, bilder 20 MB)',
    hintWithAudio:
      'PDF, Word, Excel, PowerPoint, CSV, TXT, bilder, ljud/video (max 50 MB, bilder 20 MB)',
    unknownType: '(okänd)',
    unsupportedType:
      'Filtypen {{ext}} stöds inte. Använd PDF, Word, Excel, PowerPoint, CSV, TXT eller en bild (PNG, JPG, GIF, WebP, HEIC).',
    unsupportedTypeWithAudio:
      'Filtypen {{ext}} stöds inte. Använd PDF, Word, Excel, PowerPoint, CSV, TXT, en bild (PNG, JPG, GIF, WebP, HEIC) eller en ljud-/videofil.',
    tooLarge: 'Filen är för stor ({{size}}). Max {{max}}.',
    failed: 'Uppladdning misslyckades',
    networkError: 'Nätverksfel',
  },
  viewer: {
    defaultFilename: 'dokument.pdf',
    loadError: 'Kunde inte ladda PDF-filen',
    print: 'Skriv ut',
    downloadPdf: 'Ladda ner PDF',
    downloadOriginal: 'Ladda ner original',
    loading: 'Laddar PDF...',
    zoom: 'Zoom',
    zoomIn: 'Zooma in',
    zoomOut: 'Zooma ut',
    fitWidth: 'Anpassa till bredd',
    zoomPercent: '{{percent}} %',
    image: {
      loadError: 'Kunde inte visa bilden',
      failed: 'Bilden kunde inte läsas. Ladda ner originalet eller ladda upp den igen.',
      openLarge: 'Visa i full storlek',
      description: 'Beskrivning (AI)',
      describing: 'HUB beskriver bilden…',
    },
  },
  drawings: {
    sortLabel: 'Sortera:',
    sortUpdated: 'Senast uppdaterad',
    sortName: 'Namn',
    create: 'Skapa ny whiteboard',
    createFirst: 'Skapa din första whiteboard',
    newTitle: 'Tavla {{date}}',
    loading: 'Laddar...',
    loadingBoard: 'Laddar whiteboard...',
    loadError: 'Kunde inte ladda whiteboard',
    empty: 'Inga whiteboards ännu',
    updated: 'Uppdaterad {{date}}',
    deleteDialog: {
      title: 'Ta bort whiteboard',
      description: 'Är du säker på att du vill ta bort "{{title}}"? Detta går inte att ångra.',
      cancel: 'Avbryt',
      confirm: 'Ta bort',
      deleting: 'Tar bort...',
    },
  },
  whiteboard: {
    loading: 'Laddar whiteboard...',
    syncing: 'Synkar whiteboard...',
    untitled: 'Ny whiteboard',
    unknownUser: 'Okänd',
    saved: 'Sparad',
    saving: 'Sparar...',
    saveFailed: 'Misslyckades',
    save: 'Spara',
  },
}

export default documents
